<template>
  <div class="dialog-container dialog-light">
    <div class="dialog dialog-md">
      <div class="loader-outer">
        <div class="loader"></div>
      </div>
      <!-- header -->
      <ax-dialog-header
        :noIcon="true"
        :text="text"
      ></ax-dialog-header>
    </div>
  </div>
</template>

<script>
export default({
  name: "sync-diaog",
  props: {
    text: {
      default: 'Resync in progress',
      type: String
    }
  }
})
</script>

<style scoped>
  .loader-outer {
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
  }
  .loader {
    width: 60px;
    aspect-ratio: 1;
    position: relative;
  }
  .loader:before,
  .loader:after {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    margin: -16px 0 0 -16px;
    width: 32px;
    aspect-ratio: 1;
    background: #DF5A3E;
    animation:
      l1-1 2s  infinite,
      l1-2 .5s infinite;
  }
  .loader:after {
    background:rgb(0, 185, 54);;
    animation-delay: -1s,0s;
  }
  @keyframes l1-1 {
    0%   {top:0   ;left:0}
    25%  {top:100%;left:0}
    50%  {top:100%;left:100%}
    75%  {top:0   ;left:100%}
    100% {top:0   ;left:0}
  }
  @keyframes l1-2 {
    80%,100% {transform: rotate(0.5turn)}
  }
</style>